<template>
  <div :class="props.needHover ? 'business-card-wrapper-hover bc-white' : 'business-card-wrapper bc-white'">
    <slot name="header"></slot>
    <div class="flex-start c-333 title" v-if="props.title">
      <!-- <span class="iconfont iconbilibili- mr8 font-size-18"></span> -->
      <span class="font-weight-600 font-size-16">{{ props.title }}</span>
      <slot name="extra"></slot>
    </div>
    <template v-if="showHeader || props.title">
      <div class="mt16 mb24" v-if="props.border"></div>
      <div v-else-if="props.headerMargin" class="mt16 mb32"></div>
    </template>
    <slot name="header-btn"></slot>
    <slot></slot>
    <div class="border-bottom-1 mb16 mt24" v-if="showFooter && props.showFootTopBorder"></div>
    <slot name="footer"></slot>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref, useSlots } from 'vue'

const slots = useSlots()
const props = withDefaults(
  defineProps<{
    title?: string
    border?: boolean
    needHover?: boolean
    headerMargin?: boolean
    showFootTopBorder?: boolean
  }>(),
  {
    title: '',
    border: false,
    needHover: false,
    headerMargin: true,
    showFootTopBorder: false
  }
)

const showHeader = ref(false)
const showFooter = ref(false)

onMounted(() => {
  if (slots.header) {
    showHeader.value = true
  }

  if (slots.footer) {
    showFooter.value = true
  }
})
</script>

<style lang="less">
.business-card-wrapper {
  position: relative;
  padding: 24px;
  border-radius: 12px;

  &.huahuo-plus {
    border: 1px solid transparent;
    border-image: linear-gradient(90deg, #fffbf6, #f8e6d4) 1;
  }

  .card-header-btn {
    position: absolute;
    right: 24px;
    top: 16px;
  }

  .border-bottom-1 {
    border-bottom: 1px solid rgba(204, 204, 204, 0.3);
  }
}

.business-card-wrapper-hover {
  position: relative;
  box-shadow: 0px 0px 20px 0px rgba(141, 144, 153, 0.1);
  border-radius: 4px;

  .card-header-btn {
    position: absolute;
    right: 24px;
    top: 16px;
  }

  .border-bottom-1 {
    border-bottom: 1px solid rgba(204, 204, 204, 0.3);
  }

  &:hover {
    position: relative;
    border-radius: 4px;
    -webkit-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    transform: translateY(-2px);
    transition: box-shadow 0.2s linear, transform 0.2s linear;
    -webkit-transition: box-shadow 0.2s linear, -webkit-transform 0.2s linear;
    -moz-transition: box-shadow 0.2s linear, -moz-transform 0.2s linear;
  }
}
</style>
